import React, { useState } from "react";
import "./styles.less";
import { useTranslation } from "react-i18next";
import { useInterval } from "react-use";
import classnames from "classnames";
// import { SilderDot } from "../../components/SilderDot";

export const MainComment = () => {
  const { t } = useTranslation();
  const [element, setElement] = useState(1);
  const commonList = [
    {
      common: `${t("page.other.item-one.common")}`,
      author: `—— ${t("page.other.item-one.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-dongnan-university.png",
    },
    {
      common: `${t("page.other.item-two.common")}`,
      author: `—— ${t("page.other.item-two.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-aws.png",
      // urlimg: "//files.authing.co/authing-website/home-customer-amazon.png",
    },
    {
      common: `${t("page.other.item-three.common")}`,
      author: `—— ${t("page.other.item-three.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-heigh-education.png",
    },
    {
      common: `${t("page.other.item-four.common")}`,
      author: `—— ${t("page.other.item-four.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-zhijiang-lab.png",
    },
    {
      common: `${t("page.other.item-five.common")}`,
      author: `—— ${t("page.other.item-five.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-k-trust.png",
    },
    {
      common: `${t("page.other.item-six.common")}`,
      author: `—— ${t("page.other.item-six.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-dongnan-fengtian.png",
    },
    {
      common: `${t("page.other.item-seven.common")}`,
      author: `—— ${t("page.other.item-seven.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-jcd.png",
    },
    {
      common: `${t("page.other.item-eight.common")}`,
      author: `—— ${t("page.other.item-eight.author")}`,
      urlimg: "//files.authing.co/authing-website/home-customer-heigh-deephow.png",
    },
  ];
  const commonIndexList = [
    { imgUrl: "//files.authing.co/authing-website/home-logo-dongnan.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-aws.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-education.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-zhijiang.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-kuangxin.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-toyota.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-jcdecaux.png" },
    { imgUrl: "//files.authing.co/authing-website/home-logo-deephow.png" },
  ];
  useInterval(() => {
    if (element < 8) {
      setElement(element + 1);
    } else {
      setElement(1);
    }
  }, 8000);
  const onMouseLeave = () => {};
  const SilderDot = () => {
    return (
      <div className={classnames("silder-dot-container")}>
        {commonIndexList?.map((item, index) => {
          return (
            <div>
              <div
                key={index}
                className={classnames("item-img", {
                  active: element - 1 === index,
                })}
                onMouseEnter={() => setElement(index + 1)}
                onMouseLeave={onMouseLeave}
              >
                <img src={item.imgUrl} alt="authing logo" width="150px" />
              </div>
            </div>
          );
        })}
      </div>
    );
  };
  return (
    <div className="common-block">
      <div className="inner">
        <section className="common-section">
          <div className="top">
            <div className="headline">{t("page.other.title")}</div>
          </div>
          <div className="common-warp">
            {commonList.map((item, index) => {
              const cls = classnames({
                common: true,
                visible: element === index + 1,
              });
              return (
                <div className={cls}>
                  <div className="common-icon">
                    <img src={item.urlimg} alt="" />
                  </div>
                  <div className="text-box">
                    <div className="commas-bg">
                      <img src="//files.authing.co/authing-website/commas-bg.svg" alt="authing background" />
                    </div>
                    <div>
                      <div className="common-text">{item.common}</div>
                      <div className="common-author">{item.author}</div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
          {SilderDot()}
          {/* <SilderDot arrImg={commonIndexList} length={commonList.length} current={element - 1}></SilderDot> */}
        </section>
      </div>
    </div>
  );
};
